import React from 'react';

import portalMarkPng from '../../../assets/agent-portal/icons/semantic/portal-mark.png';
import homePng from '../../../assets/agent-portal/icons/semantic/home.png';
import customersPng from '../../../assets/agent-portal/icons/semantic/customers.png';
import customerNewPng from '../../../assets/agent-portal/icons/semantic/customer-new.png';
import customerActivePng from '../../../assets/agent-portal/icons/semantic/customer-active.png';
import customerLinkPng from '../../../assets/agent-portal/icons/semantic/customer-link.png';
import customerChatPng from '../../../assets/agent-portal/icons/semantic/customer-chat.png';
import teamChatPng from '../../../assets/agent-portal/icons/semantic/team-chat.png';
import morePng from '../../../assets/agent-portal/icons/semantic/more.png';
import earningsPng from '../../../assets/agent-portal/icons/semantic/earnings.png';
import walletPng from '../../../assets/agent-portal/icons/semantic/wallet.png';
import withdrawPng from '../../../assets/agent-portal/icons/semantic/withdraw.png';
import withdrawalHistoryPng from '../../../assets/agent-portal/icons/semantic/withdrawal-history.png';
import gameCreditsPng from '../../../assets/agent-portal/icons/semantic/game-credits.png';
import coinCostPng from '../../../assets/agent-portal/icons/semantic/coin-cost.png';
import inviteAgentPng from '../../../assets/agent-portal/icons/semantic/invite-agent.png';
import reportsPng from '../../../assets/agent-portal/icons/semantic/reports.png';
import analyticsPng from '../../../assets/agent-portal/icons/semantic/analytics.png';
import ledgerPng from '../../../assets/agent-portal/icons/semantic/transparent-ledger.png';
import moneyFlowPng from '../../../assets/agent-portal/icons/semantic/money-flow.png';
import expensesPng from '../../../assets/agent-portal/icons/semantic/expenses.png';
import referralTreePng from '../../../assets/agent-portal/icons/semantic/referral-tree.png';
import profilePng from '../../../assets/agent-portal/icons/semantic/profile.png';
import howItWorksPng from '../../../assets/agent-portal/icons/semantic/how-it-works.png';
import securityPng from '../../../assets/agent-portal/icons/semantic/security.png';
import supportHelpPng from '../../../assets/agent-portal/icons/semantic/support-help.png';
import supportManagersPng from '../../../assets/agent-portal/icons/semantic/support-managers.png';
import supportDevelopmentPng from '../../../assets/agent-portal/icons/semantic/support-development.png';

import navHomePng from '../../../assets/agent-portal/icons/nav/home.png';
import navCustomersPng from '../../../assets/agent-portal/icons/nav/customers.png';
import navChatPng from '../../../assets/agent-portal/icons/nav/chat.png';
import navMorePng from '../../../assets/agent-portal/icons/nav/more.png';

import bellPng from '../../../assets/agent-portal/icons/utility/bell.png';
import calendarPng from '../../../assets/agent-portal/icons/utility/calendar.png';
import cameraPng from '../../../assets/agent-portal/icons/utility/camera.png';
import copyPng from '../../../assets/agent-portal/icons/utility/copy.png';
import eyePng from '../../../assets/agent-portal/icons/utility/eye.png';
import eyeOffPng from '../../../assets/agent-portal/icons/utility/eye-off.png';
import sunPng from '../../../assets/agent-portal/icons/utility/sun.png';
import moonPng from '../../../assets/agent-portal/icons/utility/moon.png';
import logoutPng from '../../../assets/agent-portal/icons/utility/logout.png';

function createPngIcon(name, src, { section = false, utility = false, intrinsicSize = 160 } = {}) {
  const PngIcon = React.forwardRef(({
    className = '',
    width = intrinsicSize,
    height = intrinsicSize,
    'aria-label': ariaLabel,
    ...props
  }, ref) => (
    <img
      ref={ref}
      {...props}
      src={src}
      width={width}
      height={height}
      alt=""
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
      role={ariaLabel ? 'img' : undefined}
      decoding="async"
      draggable="false"
      className={`so-agent-icon so-agent-png-icon${section ? ' so-agent-section-icon' : ''}${utility ? ' so-agent-png-utility' : ''} ${className}`.trim()}
      data-so-agent-icon={name}
      data-so-agent-icon-source="png"
    />
  ));

  PngIcon.displayName = `SoAgentPng${name.replace(/(^|-)([a-z])/g, (_, __, letter) => letter.toUpperCase())}Icon`;
  return PngIcon;
}

export const PortalMarkIcon = createPngIcon('portal-mark', portalMarkPng, { section: true });
export const HomeSectionIcon = createPngIcon('section-home', homePng, { section: true });
export const CustomersGroupIcon = createPngIcon('customers', customersPng, { section: true });
export const LeadCenterIcon = createPngIcon('section-lead-center', customerNewPng, { section: true });
export const CustomerChatSectionIcon = createPngIcon('section-customer-chat', customerChatPng, { section: true });
export const MoreSectionIcon = createPngIcon('section-more', morePng, { section: true });
export const EarningsSectionIcon = createPngIcon('section-earnings', earningsPng, { section: true });
export const CoinStackIcon = createPngIcon('coin-cost', coinCostPng);
export const CreditsUsedIcon = createPngIcon('credits-used', gameCreditsPng);
export const GamesSectionIcon = createPngIcon('section-game-credits', gameCreditsPng, { section: true });
export const InviteAgentIcon = createPngIcon('invite-agent', inviteAgentPng, { section: true });
export const NewJoinedIcon = createPngIcon('new-joined-customer', customerNewPng);
export const ReportsSectionIcon = createPngIcon('section-reports', reportsPng, { section: true });
export const AnalyticsSectionIcon = createPngIcon('section-analytics', analyticsPng, { section: true });
export const TransparentLedgerIcon = createPngIcon('transparent-ledger', ledgerPng, { section: true });
export const WithdrawActionIcon = createPngIcon('withdraw-action', withdrawPng);
export const WalletBalanceIcon = createPngIcon('wallet-balance', walletPng);
export const WithdrawalHistoryIcon = createPngIcon('withdrawal-history', withdrawalHistoryPng, { section: true });
export const MoneyFlowIcon = createPngIcon('money-flow', moneyFlowPng, { section: true });
export const ExpensesReceiptIcon = createPngIcon('expenses', expensesPng, { section: true });
export const ReferralLinkIcon = createPngIcon('customer-link', customerLinkPng, { section: true });
export const ReferralTreeIcon = createPngIcon('referral-tree', referralTreePng, { section: true });
export const TeamChatIcon = createPngIcon('team-chat', teamChatPng, { section: true });
export const HowItWorksIcon = createPngIcon('how-it-works', howItWorksPng, { section: true });
export const ProfileSectionIcon = createPngIcon('section-profile', profilePng, { section: true });
export const ActiveCustomerIcon = createPngIcon('active-customer', customerActivePng);

export const ShieldCheck = createPngIcon('protected', securityPng);
export const CheckCircle2 = createPngIcon('positive-customer', customerActivePng);
export const Headphones = createPngIcon('support-help', supportHelpPng);
export const LifeBuoy = createPngIcon('support-help', supportHelpPng);
export const UserCog = createPngIcon('support-managers', supportManagersPng);
export const Code2 = createPngIcon('support-development', supportDevelopmentPng);

// Semantic aliases and the most visible utilities are intentionally local to
// the authenticated portal. Directional and live-input controls remain vector
// based so their state, focus, and motion stay crisp at very small sizes.
export const Users = CustomersGroupIcon;
export const Wallet = WalletBalanceIcon;
export const CircleDollarSign = EarningsSectionIcon;
export const BadgeDollarSign = EarningsSectionIcon;
export const BarChart3 = AnalyticsSectionIcon;
export const LineChart = AnalyticsSectionIcon;
export const GitBranch = ReferralTreeIcon;
export const Network = ReferralTreeIcon;
export const Link2 = ReferralLinkIcon;
export const ScrollText = TransparentLedgerIcon;
export const Gamepad2 = GamesSectionIcon;
export const MessageCircle = CustomerChatSectionIcon;
export const MessageSquareText = TeamChatIcon;

export const NavHomeIcon = createPngIcon('nav-home', navHomePng, { intrinsicSize: 128 });
export const NavCustomersIcon = createPngIcon('nav-customers', navCustomersPng, { intrinsicSize: 128 });
export const NavChatIcon = createPngIcon('nav-chat', navChatPng, { intrinsicSize: 128 });
export const NavMoreIcon = createPngIcon('nav-more', navMorePng, { intrinsicSize: 128 });

export const Bell = createPngIcon('utility-bell', bellPng, { utility: true, intrinsicSize: 128 });
export const CalendarDays = createPngIcon('utility-calendar', calendarPng, { utility: true, intrinsicSize: 128 });
export const Camera = createPngIcon('utility-camera', cameraPng, { utility: true, intrinsicSize: 128 });
export const Copy = createPngIcon('utility-copy', copyPng, { utility: true, intrinsicSize: 128 });
export const Eye = createPngIcon('utility-eye', eyePng, { utility: true, intrinsicSize: 128 });
export const EyeOff = createPngIcon('utility-eye-off', eyeOffPng, { utility: true, intrinsicSize: 128 });
export const Sun = createPngIcon('utility-sun', sunPng, { utility: true, intrinsicSize: 128 });
export const Moon = createPngIcon('utility-moon', moonPng, { utility: true, intrinsicSize: 128 });
export const LogOut = createPngIcon('utility-logout', logoutPng, { utility: true, intrinsicSize: 128 });

export function IconTile({ icon: Icon, tone = 'green', className = '', ...props }) {
  return (
    <span className={`agent-dashboard-icon-tile is-${tone} ${className}`.trim()} data-tone={tone} aria-hidden="true" {...props}>
      <Icon />
    </span>
  );
}
